import { Container } from 'inversify';
import getDecorators from 'inversify-inject-decorators';
import 'reflect-metadata';

// Inversify links dependencies via a container which exposes functions as decorators
// All Injectables should link to this configuration in order to place nice within the inversify system.

// Define a container to be filled later
// To Avoid a circular dependency, all container elements will be defined externally.
const container = new Container();

// Generate functions to be imported for items to be injected
const { lazyInject, lazyInjectNamed, lazyInjectTagged, lazyMultiInject }  = getDecorators(container);

// A Definition of tags to be used to define a a specific type of dependency.
// When adding a new element for injection, make sure it has a unique type tag associated with it
const TYPES = {
    REDUX_STORE: 'REDUX_STORE',
    MEEPO_SERVICE: 'MEEPO_SERVICE',
    USER_SERVICE: 'USER_SERVICE',
    FIREBASE: 'FIREBASE'
};

// Expose all the functions to be used by consumers of the injected components
export {container, lazyInject, lazyInjectNamed, lazyInjectTagged, lazyMultiInject, TYPES};



// WEBPACK FOOTER //
// ./src/utils/inversify-config.ts